// Environment Helper Utility

/**
 * Clear all localStorage data related to AndonX
 */
export function clearAndonXStorage() {
  localStorage.removeItem('andonx_api_key');
  localStorage.removeItem('andonx_environment');
  // AndonX localStorage cleared
}

/**
 * Get current environment from localStorage or config default
 */
export function getCurrentEnvironment() {
  const savedEnvironment = localStorage.getItem('andonx_environment');
  return savedEnvironment || 'production';
}

/**
 * Set environment and save to localStorage
 */
export function setCurrentEnvironment(environment) {
  localStorage.setItem('andonx_environment', environment);
  // Environment set
}

/**
 * Get current API key from localStorage or config default
 */
export function getCurrentApiKey() {
  const savedApiKey = localStorage.getItem('andonx_api_key');
  return savedApiKey || 'gthhcBudmdMywk4zUEtKG0CGHN5gmSWE';
}

/**
 * Set API key and save to localStorage
 */
export function setCurrentApiKey(apiKey) {
  localStorage.setItem('andonx_api_key', apiKey);
  // API key updated
}

/**
 * Reset to production environment
 */
export function resetToProduction() {
  setCurrentEnvironment('production');
  // Reset to production environment
}

/**
 * Reset to test environment
 */
export function resetToTest() {
  setCurrentEnvironment('test');
  // Reset to test environment
}

/**
 * Log current environment state
 */
export function logEnvironmentState() {
  const environment = getCurrentEnvironment();
  const apiKey = getCurrentApiKey();

  // Current AndonX Environment State (commented out for production)
  // console.log('Current AndonX Environment State:', {
  //   environment,
  //   apiKeyLength: apiKey.length,
  //   apiKeyPreview: apiKey.substring(0, 8) + '...'
  // });
}

/**
 * Force clear all AndonX data and reset to production
 */
export function forceClearAndReset() {
  clearAndonXStorage();
  resetToProduction();
  // Force cleared all data and reset to production

  // Reload the page to ensure clean state
  window.location.reload();
}
